// Pages an admin can grant to a staff member. Dashboard is always visible.
export const GRANTABLE_PAGES = [
  { key: "lrs", label: "Lorry Receipts" },
  { key: "board", label: "Status Board" },
  { key: "consignments", label: "Consignments" },
  { key: "payroll", label: "Payroll & Office" },
  { key: "quotations", label: "Quotations" },
  { key: "leads", label: "Website Leads" },
  { key: "bids", label: "L&T Bids" },
  { key: "invoices", label: "Invoices" },
  { key: "aging", label: "Aging Report" },
  { key: "personal_accounts", label: "Personal Accounts" },
  { key: "payments", label: "UPI Payments" },
  { key: "reports", label: "Reports" },
  { key: "assistant", label: "AI Assistant" },
  { key: "inbox", label: "Inbox Assistant" },
  { key: "reminders", label: "Reminders" },
  { key: "summary", label: "Summary" },
  { key: "expenses", label: "Expenses" },
  { key: "bank-statements", label: "Bank Statements" },
  { key: "masters", label: "Vehicles & Drivers" },
  { key: "live_tracking", label: "Live Tracking" },
  { key: "field", label: "Field Mode (POD)" },
];

// Admins see everything; staff see Dashboard plus whatever pages were granted.
export function canAccess(user, key) {
  if (!user) return false;
  if (user.role === "admin") return true;
  if (!key || key === "dashboard") return true;
  return (user.permissions || []).includes(key);
}
